export default __webpack_public_path__ + "static/media/assets-avatar-img.2736d5fe.png";